'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_UserKind$Pharmacy$() {
}
export { $c_Lapp_data_UserKind$Pharmacy$ as $c_Lapp_data_UserKind$Pharmacy$ };
$c_Lapp_data_UserKind$Pharmacy$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_UserKind$Pharmacy$.prototype.constructor = $c_Lapp_data_UserKind$Pharmacy$;
/** @constructor */
function $h_Lapp_data_UserKind$Pharmacy$() {
}
export { $h_Lapp_data_UserKind$Pharmacy$ as $h_Lapp_data_UserKind$Pharmacy$ };
$h_Lapp_data_UserKind$Pharmacy$.prototype = $c_Lapp_data_UserKind$Pharmacy$.prototype;
$c_Lapp_data_UserKind$Pharmacy$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_UserKind$Pharmacy$.prototype.hashCode__I = (function() {
  return (-1612338989);
});
$c_Lapp_data_UserKind$Pharmacy$.prototype.toString__T = (function() {
  return "Pharmacy";
});
$c_Lapp_data_UserKind$Pharmacy$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lapp_data_UserKind$Pharmacy$.prototype.productPrefix__T = (function() {
  return "Pharmacy";
});
$c_Lapp_data_UserKind$Pharmacy$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_UserKind$Pharmacy$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_UserKind$Pharmacy$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lapp_data_UserKind$Pharmacy$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_UserKind$Pharmacy$, "app.data.UserKind$Pharmacy$", ({
  Lapp_data_UserKind$Pharmacy$: 1,
  Lapp_data_UserKind: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lapp_data_UserKind$Pharmacy$ as $d_Lapp_data_UserKind$Pharmacy$ };
var $n_Lapp_data_UserKind$Pharmacy$;
function $m_Lapp_data_UserKind$Pharmacy$() {
  if ((!$n_Lapp_data_UserKind$Pharmacy$)) {
    $n_Lapp_data_UserKind$Pharmacy$ = new $c_Lapp_data_UserKind$Pharmacy$();
  }
  return $n_Lapp_data_UserKind$Pharmacy$;
}
export { $m_Lapp_data_UserKind$Pharmacy$ as $m_Lapp_data_UserKind$Pharmacy$ };
//# sourceMappingURL=app.data.-User-Kind$-Pharmacy$.js.map
